import { Component, OnInit, ViewChild } from '@angular/core';
import { GamaService } from '../../../services/entities/gama.service';
import { Gama } from '../../../models/Gama';
import { OrderWithGamas } from '../../../models/Order';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../../services/entities/order.service';
import { DateService } from '../../../services/date.service';
import { Worker } from '../../../models/Worker';


@Component({
  selector: 'app-edit-gama',
  templateUrl: './edit-gama.component.html',
  styleUrl: './edit-gama.component.scss'
})
export class EditGamaComponent implements OnInit{
  
  constructor(private route: ActivatedRoute,
              private router: Router,
              private gamaService: GamaService,
              private orderService: OrderService,
              public dateService: DateService){}

  //Action Vars
  action: string = 'edit'  
  form_in_progress: boolean = false

  //Start Values
  start_values = {operations: 11, materials: 5}
  target_gama: Gama = {id: '', order_id: '', index: 0, active: true, designations: ['', '', '', '', ''], s_c_one: '', affaire: '', treatment: '', operations: [], materials: [], actions: []}
  order: OrderWithGamas = {id: '', number: '', client: '', denomination: '', request: '', gamas: []}
  
  ngOnInit(){
    this.route.params.subscribe(async params => {
      this.action = params['action']

      if(!this.action) this.router.navigate(['/orders'])

      if(this.action === 'create'){
        this.order.id = params['param_id']
        if(!this.order.id) this.router.navigate(['/orders'])

        this.target_gama.order_id = this.order.id
        this.getGamaOrder()

        this.initializeOperationsAndMaterials()
      }

      else{
        this.target_gama.id = params['param_id']
        if(!this.target_gama.id) this.router.navigate(['/orders'])

        this.gamaService.getGamaWithActions(this.target_gama.id).subscribe(
          gama => {
            if(!gama) this.router.navigate(['/orders'])
            this.target_gama = gama
            this.order.id = gama.order_id

            this.getGamaOrder()
          },
          error => {
            console.error('Gama with ID: ' + this.target_gama.id + ' not found.', error)
          }
        )
      }
    })
  }

  addMaterial(){
    this.target_gama.materials.push({s: '', ref: '', material: '', weight: '', review: '', ubication: {ubication_one: '', ubication_two: ''}})
    this.target_gama.operations.pop()
  }

  addOperation(){
    this.target_gama.operations.push({date: '', name: '', machine: '', operation: '', time: ''})
    this.target_gama.materials.pop()
  }

  getGamaOrder(){
    this.orderService.getOrderById(this.order.id).subscribe(
      order => {
        this.order = order
      },
      error => {
        console.error('Order with ID: ' + this.order.id + ' not found.', error)
      }
    )
  }

  registerGama(){
    const new_gama: Partial<Gama> = {...this.target_gama}
    delete new_gama.id
    delete new_gama.actions

    this.gamaService.createGama(new_gama).subscribe(
      gama => {
        this.router.navigate(['/gamas/view/' + gama.id])
      },
      error => {
        console.error('Error creating Gama', error)
      }
    )
  }

  updateGama(){
    const updated_gama: Partial<Gama> = {...this.target_gama}
    delete updated_gama.actions

    this.gamaService.updateGama(updated_gama).subscribe(
      gama => {
        console.log("gama id", gama.id)
        this.router.navigate(['/gamas/view/' + gama.id])
      },
      error => {
        console.error('Error updating Gama', error)
      }
    )
  }

  initializeOperationsAndMaterials(){
    this.target_gama.operations = []
    this.target_gama.materials = []
    for(let i = 0; i < this.start_values.operations; i++){
      this.target_gama.operations.push({date: '', name: '', machine: '', operation: '', time: ''})
    }
    for(let i = 0; i < this.start_values.materials; i++){
      this.target_gama.materials.push({s: '', ref: '', material: '', weight: '', review: '', ubication: {ubication_one: '', ubication_two: ''}})
    }
  }
}